import React from 'react';
import { Link } from 'react-router-dom';
import useSettingsStore from '../store/useSettingsStore';

export default function Footer() {
  const { settings, siteContent, getImageUrl } = useSettingsStore();

  const siteName = siteContent?.header?.site_name || settings?.site_title || 'Euro Drive Import';
  const logoUrl = settings?.logo_url ? getImageUrl(settings.logo_url) : null;
  const description = siteContent?.footer?.description || '';
  const copyright = siteContent?.footer?.copyright || `© ${new Date().getFullYear()} Euro Drive Import`;
  const tgChannel = settings?.telegram_channel_url || '#';

  const footerLinks = [
    { path: '/catalog', label: 'Каталог' },
    { path: '/configurator', label: 'Подбор авто' },
    { path: '/services', label: 'Услуги' },
    { path: '/reviews', label: 'Отзывы' },
    { path: '/blog', label: 'Блог' },
    { path: '/about', label: 'О компании' },
    { path: '/contacts', label: 'Контакты' },
  ];

  return (
    <footer
      className="mt-16"
      style={{
        background: 'var(--color-primary-dark)',
        borderTop: '1px solid var(--color-border)',
      }}
      data-testid="footer"
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              {logoUrl && (
                <img src={logoUrl} alt={siteName} className="h-10 w-10 rounded-full object-cover" />
              )}
              <span style={{ fontFamily: 'var(--font-heading)', color: 'var(--color-accent-gold)', fontSize: '18px' }}>
                {siteName}
              </span>
            </div>
            <p style={{ color: 'var(--color-text-secondary)', lineHeight: '1.6', fontSize: '14px' }}>
              {description}
            </p>
          </div>

          {/* Links */}
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider mb-4" style={{ color: 'var(--color-text-primary)' }}>
              Навигация
            </h4>
            <nav className="flex flex-col gap-2">
              {footerLinks.map(link => (
                <Link
                  key={link.path}
                  to={link.path}
                  className="text-sm transition-colors duration-300 hover:text-[var(--color-accent-gold)]"
                  style={{ color: 'var(--color-text-secondary)' }}
                >
                  {link.label}
                </Link>
              ))}
            </nav>
          </div>

          {/* Contacts */}
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider mb-4" style={{ color: 'var(--color-text-primary)' }}>
              Контакты
            </h4>
            <div className="flex flex-col gap-3">
              {settings?.contacts_info?.map((contact, i) => (
                <div key={i} className="text-sm" style={{ color: 'var(--color-text-secondary)' }}>
                  <span className="font-medium" style={{ color: 'var(--color-text-primary)' }}>{contact.name}</span>
                  {contact.telegram && (
                    <a
                      href={contact.telegram}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="block mt-1 transition-colors hover:text-[var(--color-accent-gold)]"
                    >
                      Telegram
                    </a>
                  )}
                </div>
              ))}
              {tgChannel && tgChannel !== '#' && (
                <a
                  href={tgChannel}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn-gold-outline text-sm py-2 px-4 mt-2 w-fit"
                >
                  Telegram-канал
                </a>
              )}
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div
          className="mt-10 pt-6 text-center text-sm"
          style={{ borderTop: '1px solid var(--color-border)', color: 'var(--color-text-muted)' }}
        >
          {copyright}
        </div>
      </div>
    </footer>
  );
}
